import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

const RequireVIP = ({ children }) => {
  const { t } = useTranslation();
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  const isScreenshotMode = (() => {
    if (typeof window === 'undefined') return false;
    if (window.__MPT_SCREENSHOT_MODE === true) return true;
    const params = new URLSearchParams(location.search || '');
    return params.get('screenshot') === '1';
  })();

  if (loading) {
    return null;
  }

  if (isScreenshotMode) {
    return children;
  }

  if (!user) {
    const redirectTo = `${location.pathname}${location.search || ''}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectTo)}`} replace />;
  }

  if (profile?.role !== 'vip' && profile?.role !== 'admin') {
    return (
      <div className="auth-container">
        <h1 className="auth-title">{t('auth.vip.forbiddenTitle')}</h1>
        <p className="auth-subtitle">{t('auth.vip.forbiddenSubtitle')}</p>
      </div>
    );
  }

  return children;
};

// SECURITY WARNING:
// This component provides CLIENT-SIDE protection only.
// It improves UX by redirecting unauthorized users, but it MUST be paired
// with Row Level Security (RLS) policies on the Supabase backend.

export default RequireVIP;
